export default __webpack_public_path__ + "static/media/m-khashi.45fd8a10.png";